export default __webpack_public_path__ + "img/AI_ART.d414e0fd.png";